var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h2',{staticClass:"title"},[_vm._v("News")]),_vm._v(" "),_vm._l((_vm.posts),function(post){return _c('PostListItem',{key:post.createdAt,attrs:{"title":post.fields.title,"description":post.fields.description,"imageUrl":post.fields.mainImage.fields.file.url,"body":post.fields.body,"date":post.fields.publishDate}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a0949cf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PostList.vue
// module id = null
// module chunks = 